export default defineNuxtRouteMiddleware(async (to, from) => {
    const precompiled = {
        "orderID": "orderID",
        "Nome": "name",
        "Cognome": "surname",
        "CF": "taxCode",
        "Iban": "iban"
    };

    const precompiledUrl = from.query.url as string;
    let lang: string | undefined;
    let code: string | undefined;

    if (to.params.code) {
        lang = to.params.step as string;
        code = to.params.code as string;
    } else if (precompiledUrl) {        
        const precompiledParams = precompiledUrl.split('/');
        lang = precompiledParams[2];
        code = precompiledParams[3];
    }
    if (!lang || !code) {
        return
    }

    if (langs.includes(lang)) {
        updateStateValue('lang', lang);
    }

    const data = await (useNuxtApp().$loadPrecompiledData as (code: string) => Promise<any>)(code);
    if (!data) {
        return;
    }

    updateStateValue('protected', false);
    updateStateValue('preCompiled', true);

    Object.keys(data as any).forEach(key => {
        const stateKey = precompiled[key as keyof typeof precompiled];
        if (stateKey) {
            updateStateValue(stateKey, data[key as keyof typeof data]);
        }
    });

});
